import React, { useState } from 'react'
import { useMain } from '../Hook/Main'


function InfiniteList({ keyList, children }) {
    const { data, Request, setData } = useMain();
    const [loading, setloading] = useState(false)
    const list = data[keyList];


    let page, next;
    if (list) {
        page = list.current_page + 1;
        next = list.next_page_url;
    }
    const request = () => {

        setloading(true);
        Request({
            url: "/" + keyList + '?page=' + page,
            callback: (response) => {
                setloading(false);
                if (response) {
                    page = response.current_page;
                    next = response.next_page_url;
                    response.data = [...list.data, ...response.data];
                    setData(keyList, response, 'data');
                }
            }
        })

    }

    return (
        <div >
            {children}
            {loading ? <div className='text-center'><span className='spinner-border spinner-border-sm'></span></div> : next && <div className='text-center' style={{ cursor: "pointer" }} onClick={request}><span className='badge bg-primary'>موارد بیشتر</span></div>}
        </div>
    )
}

export default InfiniteList